export default "__VITE_ASSET__BRB5Z31h__"